export const queryKeys = {
  vendor: {
    settings: () => ['vendor', 'settings'],
  },
  notifications: {
    unreadCount: () => ['notifications', 'unread-count'],
    list: (perPage = 30) => ['notifications', 'list', perPage],
  },
};
